<template>
  <div v-for="(wards, district) in wardsByDistrict" :key="district">
    <a-text as="h6" class="district-name">{{ district }}</a-text>
    <ward-list
      :wards="wards"
      @remove-ward="removeWardByMagicCode(wards, $event)"
    />
  </div>
</template>

<script>
import WardList from "./WardList.vue";

export default {
  name: 'WardsListByDistrict',
  components: {
    WardList,
  },
  props: {
    wardsByDistrict: {
      type: Object,
      required: true,
    },
  },
  methods: {
    removeWardByMagicCode(wards, index) {
      this.$emit('remove-ward', wards[index])
    },
  },
};
</script>
